// extracted by mini-css-extract-plugin
module.exports = {"shake":"cord-thread-view_shake__8sRvv"};